<template>
  <div id="bookId" class="book-mark-container">
    <ul class="book-mark-menu">
      <li class="book-mark-item color1" @click="handleSelect(0)">
        <span
          class="rotate-90"
          v-for="(charFont, index) in bookmarkData[0].text.split('')"
          :key="charFont + index"
          >{{ charFont }}</span
        >
      </li>
      <li class="book-mark-item color2" @click="handleSelect(1)">
        <span
          class="rotate-90"
          v-for="(charFont, index) in bookmarkData[1].text.split('')"
          :key="charFont + index"
          >{{ charFont }}</span
        >
      </li>
      <li class="book-mark-item color3" @click="handleSelect(2)">
        <span
          class="rotate-90"
          v-for="(charFont, index) in bookmarkData[2].text.split('')"
          :key="charFont + index"
          >{{ charFont }}</span
        >
      </li>

      <!-- <li
        class="book-mark-item"
        v-for="(item, index) in bookmarkData"
        :key="item.value"
        :index="index.toString()"
        @mouseenter="handleMouseEnter($event, index)"
        @mouseleave="handleMouseLeave($event, index)"
        @click="handleSelect(index)"
      >
        {{ item.text }}
        <span
          v-for="(charFont, index) in item.text.split('')"
          :key="charFont + index"
          >{{ charFont }}</span
        >
      </li> -->
    </ul>
  </div>
</template>

<script>
import ElCard from "./el-card.vue";

export default {
  name: "BookMark",

  props: {
    // bookmarkData: {
    //   type: Array,
    //   required: true,
    // },
    mountId: {
      type: String,
      required: true,
    },
    contentId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      bookmarkData: [
        { text: "Catalogue", value: "catalogue" },
        { text: "AI knowledge", value: "ai" },
        { text: "Notepad", value: "notepad" },
      ],
    };
  },
  mounted() {
    this.mountToElement();
    this.initBookmarkTab();
  },
  methods: {
    mountToElement() {
      const mountElement = document.getElementById(this.mountId);

      if (mountElement) {
        // mountElement.style.position = "relative";
        const bookMarkElement = this.$el;
        // bookMarkElement.style.position = "absolute";
        // bookMarkElement.style.top = "0";
        // bookMarkElement.style.right = "0";
        mountElement.appendChild(bookMarkElement);
      }
    },
    initBookmarkTab() {
      const mountElement = document.getElementById(this.mountId);
      // const contentElement = document.getElementById(this.contentId);
      if (mountElement) {
        // mountElement.parentNode.style.display = "flex";
        // mountElement.style.width = "100%";
        const contentContainer = document.createElement("div");
        const contentContainerId = this.contentId;
        contentContainer.style.width = "0%";
        contentContainer.style.height = "100%";
        contentContainer.setAttribute("id", contentContainerId);

        const CardConstructor = this.$root.constructor.extend(ElCard);
        const cardInstance = new CardConstructor({
          propsData: {
            contentId: contentContainerId,
            mountId: this.mountId,
            bookmarkData: this.bookmarkData,
            // bookmarkData2: this.bookmarkData,
          },
        }).$mount();
        contentContainer.appendChild(cardInstance.$el);
        mountElement.parentNode.appendChild(contentContainer);
      }
    },
    handleSelect(index) {
      const contentElement = document.getElementById(this.contentId);
      var myEvent = new CustomEvent("changeCurrentComponent", {
        detail: { activeIndex: Number(index) },
        bubbles: false,
        cancelable: true,
      });
      contentElement.dispatchEvent(myEvent);
    },
  },
};
</script>

<style lang="scss" scoped>
.book-mark-container {
  padding-top: 200px;
  position: relative;
  z-index: 99999;

  .book-mark-menu {
    background: transparent;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    // right: 0px;
    position: relative;
    z-index: 99999;

    // .book-mark-item:before {
    //   content: "";
    //   height: 0%;
    //   border: 20px solid;
    //   border-color: #42b983 #42b983 #42b983 transparent;
    //   position: absolute;
    //   right: 0;
    //   transition: right 0.1s ease;
    // }

    .book-mark-item {
      content: "";
      // right: 0;
      width: 22px;
      // height: 300px;
      font-size: 20px;
      line-height: 20px;
      padding: 20px 0;
      // margin: -30px 0 0 0;
      // background-color: #d2e5eb;
      background-color: #ff8c35;
      // border-top: 1px solid #e75353;
      // color: #555555;
      color: #ffffff;
      border-radius: 5px;
      transition: all 0.2s ease;
      cursor: pointer;
      display: flex;
      flex-direction: column;
      justify-content: start;
      align-items: center;
      box-shadow: 0px 0px 2px rgba(0, 0, 0, 0.5);
      z-index: 1;
      margin-left: auto;

      .rotate-90 {
        transform: rotate(90deg);
        display: inline-block;
        white-space: nowrap;
        white-space: pre;
        // font-family: 'Gill Sans', 'Gill Sans MT', Calibri, 'Trebuchet MS', sans-serif;
        font-family: "system-ui";
        margin-top: -5px;
      }
    }
    .color1 {
      background-color: #ff8c35;
    }
    .color2 {
      background-color: #359dff;
    }
    .color3 {
      background-color: #e94e68;
    }

    .book-mark-item:hover {
      // transform: translateX(-10px);
      // transform: scale(1.2);
      // width: 35px;
      justify-content: center;
      // box-shadow: 2px -5px 15px rgba(0, 0, 0, 0.6);
      box-shadow: 0 0 30px rgba(0, 0, 0, 0.5);

      // z-index: 10;
    }
  }
}
</style>
